import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { PVFloorSpaceOverlayHelper } from '../floor-space-overlay.helper';
import {
  FLOOR_SPACE_DETAILS_STATE_HANDLER_TOKEN,
  FloorSpaceDetailsHandlerSrv,
  States,
} from './floor-space-details-state-handler.service';

@Component({
  selector: 'pv-floor-space-details',
  template: `
    <div #overflowFloorDetails class="pv-floor-space-details-wrapper">
      <ng-container *ngIf="state$ | async as state">
        <div [ngSwitch]="state">
          <ng-container *ngSwitchCase="states.Tenants">
            <pv-spaces-details></pv-spaces-details>
          </ng-container>

          <ng-container *ngSwitchCase="states.TenantSummary">
            <pv-tenant-summary
              #tenantSummary
              [tenantIds]="tenantIds$ | async"
              (afterViewInit)="recalculateOverlayPosition()"
            ></pv-tenant-summary>
          </ng-container>
        </div>
      </ng-container>
    </div>
  `,
  styleUrls: ['./floor-space-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PVFloorSpaceDetailsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('overflowFloorDetails') overflowFloorDetails: ElementRef;

  state$: Observable<States> = null;
  states = States;
  tenantIds$: Observable<number[]>;

  #onStateChange = (state: States) => {
    this.fsOverlay?.setKeepOpen(state === States.TenantSummary);
  };

  constructor(
    private fsOverlay: PVFloorSpaceOverlayHelper,
    @Inject(FLOOR_SPACE_DETAILS_STATE_HANDLER_TOKEN) private stateHandler: FloorSpaceDetailsHandlerSrv
  ) {
    this.stateHandler.resetState();
    this.state$ = this.stateHandler.state$.pipe(tap(this.#onStateChange));
    this.tenantIds$ = this.stateHandler.stateData$.pipe(map(s => s?.tenantIds ?? []));
  }

  ngAfterViewInit(): void {
    this.fsOverlay.setElement(this.overflowFloorDetails);
    this.fsOverlay.updatePosition();
  }

  recalculateOverlayPosition() {
    this.fsOverlay.setKeepOpen(true);
    this.fsOverlay.setElement(this.overflowFloorDetails);
    this.fsOverlay.recalculatePosition();
  }

  ngOnDestroy(): void {
    this.fsOverlay.cleanPositions();
    this.stateHandler.resetState();
  }
}
